import { RichTranslator, useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import AppStoreContext from 'contexts/AppStoreContext';
import { product } from 'copy/copy';
import largeSubmittal from 'images/large-submittal.svg';
import noop from 'lodash/noop';
import React, { useContext, useEffect, useState } from 'react';
import { Project } from 'records/Project';
import { getSubmittalTemplateURL } from 'services/submittalService';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  onAddSubmittal?: () => void;
  onUploadSubmittalLog?: () => void;
  disableButtons?: boolean;
}

const NoSubmittals: React.FC<Props> = ({
  onAddSubmittal = noop,
  onUploadSubmittalLog = noop,
  disableButtons = false,
}) => {
  useEffect(() => {
    getLogTemplateUrl();
  }, []);

  const [templateUrl, setTemplateUrl] = useState<string>('');
  const { state: appState } = useContext(AppStoreContext);
  const { translate } = useTranslator(['submittalsPage']);

  const getLogTemplateUrl = async (): Promise<void> => {
    const templateUrl = await getSubmittalTemplateURL();
    setTemplateUrl(templateUrl);
  };

  const { projects, selectedProject } = appState;

  const { permissions, Status } = projects.get(selectedProject, new Project());
  const projectClosed = Status === 'Closed' || Status === 'Trial Expired';

  return (
    <div
      id="no-submittals"
      className="column grow justify-center items-center pt8"
    >
      <div className="mb4 fill-gray-5">
        <img
          src={largeSubmittal}
          alt="Large submittal illustration"
          className="b-radius-100"
        />
      </div>
      <div className="font-size-7 color-gray-9 mb2">
        {translate('submittalsPage:noSubmittals')}
      </div>
      {disableButtons || !permissions.createSubmittal ? (
        <div className="font-size-5" style={{ color: '#666666' }}>
          {translate('submittalsPage:noSubmittalsAtTheMoment')}
        </div>
      ) : (
        <>
          <div className="font-size-5 color-gray-6 mb6">
            <p>{translate('submittalsPage:getStarted')}</p>
            <p>
              {
                <RichTranslator
                  components={[
                    product.productName,
                    // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
                    <a
                      href={templateUrl}
                      className="underline cursor-pointer color-primary-dark"
                    />,
                  ]}
                  translationKey="submittalsPage:downloadTemplate"
                  variables={{
                    productName: product.productName,
                  }}
                />
              }
            </p>
          </div>
          <div className="row justify-between">
            <Button
              className="mr4"
              disabled={projectClosed}
              id="no-submittals-add-sub-btn"
              onClick={onAddSubmittal}
              size="large"
              variant="secondary"
            >
              {translate('submittalsPage:addSubmittal')}
            </Button>
            <Button
              disabled={projectClosed}
              id="no-submittals-upload-sub-log"
              onClick={onUploadSubmittalLog}
              size="large"
              variant="primary"
            >
              {translate('submittalsPage:uploadLog')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default withAppStore<Props>(NoSubmittals);
